import { BaseApi } from '../base.api'
import axios, { AxiosRequestConfig } from 'axios'
import { IBaseApi } from 'interfaces/api'
import { ApiConstant } from 'constant'

interface IUserApi extends IBaseApi {
  url: ApiConstant
}

export class UserApi extends BaseApi<IUserApi> {
  url = ApiConstant.USER_URL

  /**
   * Download user documents as ZIP
   * @param blobId - The ID of the blob to download
   * @param requestOptions - Additional request options
   * @returns Promise with the ZIP file blob
   */
  downloadZip(blobId: string, requestOptions?: AxiosRequestConfig): Promise<ArrayBuffer> {
    // Don't use baseURL, use the full URL directly
    const url = `${process.env.REACT_APP_BASE_URL}/lspbe_bo/api/users/download-zip/${blobId}`;

    // This bypasses your BaseApi which might be causing issues
    return axios({
      method: 'post',
      url: url,
      data: {},
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': requestOptions?.headers?.Authorization || ''
        // Don't include withCredentials to avoid CORS preflight issues
      }
    })
      .then(response => response.data)
      .catch(error => {
        console.error('Download error:', error);
        throw error;
      });
  }
}

export const userApi = new UserApi() 